<template>
    <div class="p-workspace__secondary_view p-workspace__secondary_view--large">
        <div class="p-workspace__secondary_view_contents">
            <div
                role="complementary"
                aria-label="Thread in conversation with @Miguel Ramos (starred)"
                data-qa="threads_flexpane"
                class="p-flexpane p-flexpane--iap1 p-flexpane--ia_details_popover"
            >
                <div
                    role="presentation"
                    style="display: contents;"
                >
                    <div
                        class="p-flexpane_header"
                        role="toolbar"
                    >
                        <div class="p-flexpane_header__primary">
                            <div class="p-flexpane_header__primary_content">
                                <div
                                    class="p-flexpane__title_container"
                                    data-qa="flexpane-title-container"
                                >Thread
                                    <div
                                        class="p-flexpane__subtitle"
                                        data-qa="subtitle"
                                    >
                                        <span class="c-link p-threads_flexpane__header_permalink">
                                            <div class="p-threads_flexpane__header_channel_name">{{channel_name}}</div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <button
                                class="c-button-unstyled c-icon_button c-icon_button--light c-icon_button--size_medium p-flexpane_header__control"
                                aria-label="Close Right Sidebar"
                                data-qa="close_flexpane"
                                delay="300"
                                data-sk="tooltip_parent"
                                type="button"
                               @click="$parent.$parent.$emit('update:active', false)"
                            ><i
                                    class="c-icon c-icon--times"
                                    type="times"
                                    aria-hidden="true"
                                ></i></button>
                        </div>
                    </div>
                    <div class="p-flexpane__body p-threads_flexpane_container p-flexpane__body--light">
                        <div class="p-file_drag_drop__container p-threads_flexpane">
                            <div class="flex_one no_min_height">
                                <slack-message
                                    type="thread-root"
                                    :channel="channel"
                                    :msg="message"
                                    @add_reaction="show_emoji_picker"
                                    @updated="updated"
                                />
                                <div class="p-thread_separator">
                                    <div class="p-threads_flexpane__separator"><span class="p-threads_flexpane__separator_count">{{replies.length}} replies</span>
                                        <hr class="p-threads_flexpane__separator_line">
                                    </div>
                                </div>
                                <slack-message
                                    type="thread"
                                    v-for="(msg, key) in replies"
                                    :channel="channel"
                                    :key="`reply-${key}`"
                                    :msg="msg"
                                    @add_reaction="show_emoji_picker"
                                    @updated="updated"
                                />
                            </div>
                        </div>
                        <div
                            class="p-threads_footer__input_container p-threads_footer__input_container--sticky_composer"
                            data-qa="reply_container"
                        >
                            <div
                                class="p-threads_footer__input p-message_input_unstyled"
                                role="group"
                                aria-label="composer"
                            >
                                <slack-message-editor
                                    :thread_ts="message.ts"
                                    @message="replies.push($event)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <slack-emoji-picker
            ref="emoji_picker"
            @selected="handle_add_reaction(selected_msg, $event)"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SlackEmojiPicker from '../emoji-picker/SlackEmojiPicker'
import SlackMessage from '../message/SlackMessage.vue'
import SlackMessageEditor from '../editor/SlackMessageEditor'
import { is_me, list_replies, reactions } from '../../slack_api'
export default {
    components: {
        SlackEmojiPicker,
        SlackMessage,
        SlackMessageEditor,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
        ]),
        ch() {
            return (this.slack_channels || []).find(ch => ch.id === this.channel)
        },
        channel_name() {
            const ch = this.ch
            return ch && (!ch.is_im && `# ${ch.name}` || ch.user_info.real_name) || ''
        },
    },
    data() {
        return {
            replies: [],
            selected_msg: null,
        }
    },
    methods: {
        handle_add_reaction(msg, { name }) {
            this.$refs.emoji_picker.hide()
            const reacted = msg.reactions && msg.reactions.some(r => r.name === name && r.users.some(u => is_me(u)))
            reactions(name, msg.ts, this.channel, reacted ? 'remove' : 'add').then(res => {
                if (res.ok) {
                    this.update_item(msg)
                }
            })
        },
        show_emoji_picker({ e, msg, type = 'reaction' }) {
            this.$nextTick(() => {
                this.selected_msg = msg
                this.$nextTick(() => {
                    this.$refs.emoji_picker.show(e)
                })
            })
        },
        update_item(msg) {
            return list_replies(this.channel, msg.ts, { inclusive: true, latest: msg.ts, limit: 1 }).then(response => {
                if (!response.ok || !response.messages.length) {
                    return
                }
                const { messages } = response
                this.updated(messages[0])
            })

        },
        updated(msg) {
            if (msg.thread_ts === msg.ts) {
                this.$emit('updated', msg)
                return
            }
            const idx = this.replies.findIndex(i => i.ts === msg.ts)
            if (idx !== -1) {
                this.replies[idx] = msg
                this.$forceUpdate()
            }
        },
    },
    mounted() {
        list_replies(this.channel, this.message.ts).then(response => {
            if (!response.ok) {
                return
            }
            const { messages } = response
            this.replies = messages.filter(i => i.ts !== this.message.ts)
            this.$forceUpdate()
        })
    },
    props: ['channel', 'message'],
}
</script>

<style>
.p-workspace__secondary_view {
  grid-template-areas: "p-workspace__secondary_view_contents";
  grid-template-rows: auto; }
.p-workspace__secondary_view.p-workspace__secondary_view:not(.p-workspace__secondary_view--primary_collapsed) {
  border: 1px solid rgba(var(--sk_foreground_low,29,28,29),.13)
; }
.p-workspace__secondary_view .p-workspace__secondary_view_contents {
  grid-area: p-workspace__secondary_view_contents;
  min-width: 0;
  min-height: 0; }
.p-workspace__secondary_view .p-workspace__secondary_view_contents .p-flexpane {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1; }
.p-workspace__secondary_view .p-workspace__secondary_view_contents .p-flexpane.p-flexpane--iap1 .p-flexpane_header {
  padding: 0 12px 0 16px; }
.p-workspace__secondary_view .p-workspace__secondary_view_contents .p-flexpane.p-flexpane--ia_details_popover .p-flexpane_header {
  --saf-0: rgba(var(--sk_primary_background,255,255,255),1)
;
  border-bottom: none;
  box-shadow: 0 1px 0 0 rgba(var(--sk_foreground_low, 29, 28, 29), 0.13)
; }
.p-workspace__secondary_view .p-workspace__secondary_view_contents .p-flexpane .p-threads_flexpane {
  overflow: auto;
  max-height: 400px; }

</style>